import { render } from "./TextFile.vue?vue&type=template&id=0b895085&scoped=true&bindings={\"name\":\"props\"}"
import script from "./TextFile.vue?vue&type=script&lang=js"
export * from "./TextFile.vue?vue&type=script&lang=js"

import "./TextFile.vue?vue&type=style&index=0&id=0b895085&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0b895085"

export default script